module.exports = false;



//////////////////
// WEBPACK FOOTER
// /usr/local/app/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0